"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var classes_1 = require("../../classes");
function isRequired() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var isBoolean = typeof value === 'boolean';
  var isNumber = typeof value === 'number';
  var hasValue = isBoolean || isNumber || !!value; // filter '', null, undefined
  var isObj = hasValue && (typeof value === 'object' || Array.isArray(value));
  var isEmptyObj = isObj && Object.keys(value).length === 0; // filter [], {}
  var isValid = hasValue && !isEmptyObj;
  var message = isValid ? '' : 'Esse campo é obrigatório';
  return new classes_1.ValidationResult(isValid, message);
}
exports.default = new classes_1.Validator(isRequired);